import {i18n} from '@/plugins/i18n'

export const transmitDescription = {
    reversal: '720',
    s719: '719',
    paya_wage: '553',
    paya: '722',
    internal: '008',
};

export const transmitDescriptionStr = {
    reversal: i18n.t('label.reversal'),
    s719: '719',
    paya_wage: i18n.t('label.paya_wage'),
    paya: i18n.t('label.paya'),
    internal: i18n.t('label.internal'),

    get(variant) {
        let text = null;

        Object.keys(transmitDescription).forEach(item => {
            if (transmitDescription[item] === variant) {
                text = transmitDescriptionStr[item];
            }
        });

        return text;
    }
};
